import { ref } from '@vue/composition-api'

export default function useFileReader () {
  var inputEl = null
  const title = ref('')
  const loading = ref(false)
  const error = ref('')
  var fileSink = null

  const reader = new FileReader()
  reader.onloadstart = () => {
    loading.value = true
  }
  reader.onload = () => {
    fileSink({ file: reader.result, name: title.value })
  }
  reader.onerror = () => {
    loading.value = false
    title.value = ''
    error.value = reader.error
    console.error('FileReader error', reader.error)
  }
  reader.onloadend = () => {
    fileSink = null
    inputEl.value = null // иначе при повторном выборе того же самого файла событие change не произойдет
  }

  const selectFile = async (callback) => {
    fileSink = callback
    error.value = ''
    title.value = ''
    inputEl.click()
    return Promise.resolve({})
  }

  const bindFileInput = (el) => {
    inputEl = el
    inputEl.addEventListener('change', (e) => {
      const { files } = e.target
      if (files.length) {
        title.value = files[0].name
        reader.readAsDataURL(files[0])
      }
    }, false)
  }

  return {
    bindFileInput,
    selectFile
  }
}
